const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="container-wide">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-bingo-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">BS</span>
            </div>
            <span className="font-semibold text-gray-900">BS Bingo</span>
          </a>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-gray-600 hover:text-gray-900 transition-colors">
              Features
            </a>
            <a href="#categories" className="text-gray-600 hover:text-gray-900 transition-colors">
              Categories
            </a>
            <a href="#platforms" className="text-gray-600 hover:text-gray-900 transition-colors">
              Platforms
            </a>
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-4">
            <a
              href="https://apps.apple.com/app/bs-bingo/id381394933"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm"
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
